function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "30.636,169.146 45.746,157.451 53.613,161.27 54.677,148.934 58.292,146.802 54.25,143.186  58.724,134.248 59.784,92.337 68.295,91.697 76.381,106.167 90.003,115.102 98.5,108.292 102.546,112.551 111.057,104.461  116.593,106.167 119.143,99.146 113.604,93.827 105.529,93.395 105.529,87.445 87.44,78.506 87.02,68.931 94.887,44.037  86.378,37.651 94.887,36.163 107.451,21.691 109.996,10.63 107.451,7.011 121.702,0 125.105,16.595 132.773,20.206 133.186,23.823  120.212,29.142 119.143,46.166 126.596,49.994 128.09,54.673 141.703,45.099 155.957,52.975 146.383,65.312 135.744,91.27  139.35,94.889 137.236,99.785 159.788,109.784 155.318,115.525 142.764,118.293 140.843,134.248 134.68,146.802 147.873,153.188  149.783,164.459 164.893,160.634 169.363,167.654 167.018,172.973 150.421,181.906 144.885,178.721 125.744,193.611  121.061,189.354 116.175,171.914 108.08,171.914 100.425,184.042 105.529,191.48 98.5,196.8 79.781,190.843 76.381,200  54.677,191.48 "
});

var Svg21 = function Svg21(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PUE",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg21, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/21.5593b26c.svg";
export { ForwardRef as ReactComponent };